import { useForm } from "@inertiajs/react";

export default function ProfileDrawerForm({ currentUser, updatePath, onSuccess }) {
  const { data, setData, patch, errors } = useForm({
    user: {
      email: currentUser?.email || "",
      first_name: currentUser?.first_name || "",
      last_name: currentUser?.last_name || "",
    },
  });

  const onSubmit = (event) => {
    event.preventDefault();
    patch(updatePath, {
      preserveScroll: true,
      onSuccess,
    });
  };

  return (
    <form id="profile-drawer-form" className="vstack gap-3" onSubmit={onSubmit}>
      {Object.keys(errors || {}).length > 0 && (
        <div className="alert alert-danger mb-0">{Object.values(errors).join(", ")}</div>
      )}
      <div>
        <label className="form-label">E-mail</label>
        <input
          className="form-control"
          value={data.user.email}
          onChange={(event) => setData("user", { ...data.user, email: event.target.value })}
          required
        />
      </div>
      <div>
        <label className="form-label">Fornavn</label>
        <input
          className="form-control"
          value={data.user.first_name}
          onChange={(event) => setData("user", { ...data.user, first_name: event.target.value })}
          required
        />
      </div>
      <div>
        <label className="form-label">Efternavn</label>
        <input
          className="form-control"
          value={data.user.last_name}
          onChange={(event) => setData("user", { ...data.user, last_name: event.target.value })}
          required
        />
      </div>
    </form>
  );
}
